import React from "react";
import type { NextPage } from "next";
import Image from "next/image";
import everliebg from "@/assets/images/everliebg1.jpg";
import styles from "@/styles/houseOfSenco.module.scss";

const SennesSecond = () => {
  return (
    <div className={styles.sennes}>
      <div
        className={styles.container}
        onClick={() => window.open("https://everlite.com/", "_blank")}
        style={{ cursor: "pointer" }}
      >
        <div className={styles.image_sennes}>
          <Image src={everliebg} alt="" />
        </div>
        <div className={styles.senns_overlay}>
          <div className={styles.senns_card}>
            <div className={styles.sen_text}>Everlite</div>
            <p>
              Indulge in the exquisite allure of Everlite by Senco Gold &
              Diamonds, meticulously crafted to elevate the modern woman’s
              glamour. A testament to sophistication and elegance, each piece is
              designed for those who appreciate luxurious subtlety in their
              everyday attire. Adorn yourself with HUID hallmarked jewellery,
              featuring the radiant gleam of gold, the timeless allure of
              diamonds, and the prestigious sheen of platinum. Illuminate your
              presence with the unparalleled brilliance of Everlite!
            </p>
            {/* <a>VISIT WEBSITE</a> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SennesSecond;
